export default __webpack_public_path__ + "static/media/Pross-Phone.1e8164a8.webp";